import './Shop.css'
import React, { useState } from 'react'
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import GoogleMap from 'google-map-react'
import { decode } from 'html-entities'
import MarkerIcon from './images/marker.svg'

const GoogleMapMarker = ({ text }) => <div style={{ height: '47px', width: '40px', overflow: 'hidden' }}>
  <img src={MarkerIcon} style={{ height: '100%', width: '100%' }}/>
</div>

function Shop (props) {
  const [direction, setDirection] = useState('map')

  return (
    <AccordionItem className={'shop'} activeClassName={'shop expanded'}>
      <AccordionItemHeading>
        <AccordionItemButton>
          <div className="accordeon_head-row">
            <div className="accordeon_head-col">
              <span className="addr">{decode(props.name)}</span>
            </div>
            <div className="accordeon_head-col">
              {
                props.address.length ?
                  <span>{decode(props.address)}</span> :
                  <></>
              }
              {
                props.subway.length ?
                  <span>{decode(props.subway)}</span> :
                  <></>
              }
            </div>

            <div className="accordeon_head-col">
              <span>{props.getMessage('CT_BNL_SM_MON_FRI')}: {props.weekdays_worktime}</span>
              <span>{props.getMessage('CT_BNL_SM_SAT_SUN')}: {props.weekend_worktime}</span>
            </div>
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="inner__content">
          <div className="inner__content__info">
            {
              props.description.length ?
                <span className="inner__content__text">{decode(props.description)}</span> :
                <></>
            }
            <div>
              <a href="#" className={`inner__content__link ${direction === 'map' ? 'selected' : ''}`}
                 onClick={e => {
                   e.preventDefault()
                   setDirection('map')
                 }}>
                {props.getMessage('CT_BNL_SM_MAP_LINK')}
              </a>
              {
                props.hasOwnProperty('photos') && Array.isArray(props.photos) && props.photos.length ?
                  <a href="#" className={`inner__content__link ${direction === 'way' ? 'selected' : ''}`}
                     onClick={e => {
                       e.preventDefault()
                       setDirection('way')
                     }}>
                    {props.getMessage('CT_BNL_SM_SLIDER_LINK')}
                  </a> :
                  <></>
              }
            </div>
            <a href={props.googleLink} target="_blank">{props.getMessage('CT_BNL_SM_GOOGLE_MAP_LINK')}</a>
          </div>
          <div className="inner__content__detail">
            {
              direction === 'map' && parseFloat(props.lat) > 0 && parseFloat(props.lng) > 0 ?
                  <GoogleMap bootstrapURLKeys={{
                    key: 'AIzaSyBh5pjyr7g-9WKLbdZBPcrT3H6V3FEGj_Q',
                    language: props.lang,
                    region: 'ua'
                  }}
                             defaultCenter={{ lat: props.lat, lng: props.lng }}
                             defaultZoom={16}>
                    <GoogleMapMarker
                      lat={props.lat}
                      lng={props.lng}
                      text="welcome to the tehnoezh.ua"/>
                  </GoogleMap> :
                  <></>
            }
            {
              direction === 'way' && props.hasOwnProperty('photos') && Array.isArray(props.photos) && props.photos.length ?
                <picture>
                  <source srcSet={props.photos[0].CONVERTED_SRC} type="image/webp"/>
                  <img src={props.photos[0].SRC} alt={decode(props.name)}/>
                </picture> :
                <></>
            }
          </div>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  )
}

export default Shop